import { Database } from 'lucide-react'

export function PerformancePage() {
    return (
        <div className="flex-1 flex items-center justify-center p-6 md:p-10">
            <div className="text-center max-w-md">
                <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-primary/10 flex items-center justify-center">
                    <Database className="h-8 w-8 text-primary" />
                </div>
                <h1 className="app-page-title mb-3">Performance Module</h1>
                <p className="app-page-subtitle font-medium mb-2">Coming Soon</p>
                <p className="app-card-description">
                    Raw tabular views of your data will be available here. Export and analyze your
                    competitive intelligence data.
                </p>
            </div>
        </div>
    )
}
